import React from 'react'

//  Styles
import styles from './StateImpactTable.module.scss'

const StateImpactTable = ( { state } ) => {

  const stateInfo = require('../../data/impact/' + state + '.json')

  const formatNumber = number => {
    return new Intl.NumberFormat().format(number);
  }

  const tableRows = stateInfo.data.map(value => 
    <tr>
      <td>{ formatNumber(value['topImpact']) }</td>
      <td>{ formatNumber(value['regionImpact']) }</td>
      <td>{ value['text'] }</td>
    </tr>
  );

	return (
    <div>
      <h2 className="section__title__secondary">
        Estimated Gains { state } Could Expect if Performance Improves to Match Top States
      </h2>
      <div>
        <table className={ styles.table__impact }>
          <thead>
            <tr>
              <th>Top State in the U.S.</th>
              <th>Top State in the { stateInfo.region } region</th>
              <th>Gains for { state }</th>
            </tr>
          </thead>
          <tbody>
            { tableRows }
          </tbody>
        </table>
        <div className={styles.table__footnote}>
          <p>Estimated impact if this state’s performance improved to the rate of two benchmark levels — a national benchmark set at the level of the best-performing state and a regional benchmark set at the level of the top-performing state in region (<a href="https://www.bea.gov">www.bea.gov</a>: Great Lakes, Mid-Atlantic, New England, Plains, Rocky Mountains, Southeast, Southwest, West). Benchmark states have an estimated impact of zero (0).</p>
        </div>
      </div>
    </div>
	)
}

export default StateImpactTable


// WEBPACK FOOTER //
// ./src/components/StateImpactTable/StateImpactTable.js